// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2uOPz","colCheckbox":"styles_colCheckbox__DYA6_"};